module.exports = {
    "collapse": `Recolher`,
    "expand": `Expandir`
};


//# sourceMappingURL=pt-BR.main.js.map
